/* ─── Dynamic Equipment Fit (proof — Bobcat T650) ─────────────────────────────
   The make/model page is a shell; the REAL fitment lives on the selected track.
   The picker (mm-regen-fitment) emits `mmf:track-selected` with the chosen track's
   handle. We fetch that track's cross-brand machine list from product-enhance and
   render searchable, accessible brand cards — updated live as the selection changes. */
(function(){
  var cache = {}, uid = 0;
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  // Title-case brand names for a premium read, but keep short acronyms (JCB, IHI, CAT, ASV) uppercase.
  function tcase(s){ return String(s || '').trim().split(/\s+/).map(function(w){ return w.length <= 3 ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); }).join(' '); }
  var $ = function(id){ return document.getElementById(id); };
  function content(){ return $('pp-mmfit-content'); }

  // Resolve a compatible machine to its make/model product page (the "make model page").
  // Handles vary (e.g. kubota-svl75-2w-rubber-tracks) so we look it up via native search
  // rather than guessing. Returns Promise<'/products/<handle>' | null>. Cached per machine.
  var mmUrlCache = {};
  function mmProductUrl(makeName, modelName){
    // Clean name (no parens) is best for the search QUERY; the full name (incl. any
    // "(-1)" suffix) gives a precise handle MATCH so we never pick the wrong variant.
    var clean = String(modelName || '').replace(/\s*\([^)]*\)\s*/g, ' ').trim();
    var mh = String(modelName || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    var key = (makeName + '|' + mh).toLowerCase();
    if (mmUrlCache[key]) return mmUrlCache[key];
    mmUrlCache[key] = fetch('/search/suggest.json?q=' + encodeURIComponent(makeName + ' ' + clean) + '&resources[type]=product&resources[limit]=10', { headers: { 'Accept':'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){
        var ps = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        for (var i = 0; i < ps.length; i++){
          if ((ps[i].type || '') !== 'Mfg-Models') continue;
          var hn = (ps[i].handle || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          if (mh && hn.indexOf(mh) >= 0) return '/products/' + ps[i].handle;   // must contain the model
        }
        return null;
      })
      .catch(function(){ return null; });
    return mmUrlCache[key];
  }

  function render(equipment){
    var c = content(); if(!c) return 0;
    equipment = equipment || []; c.innerHTML = ''; var total = 0;
    equipment.forEach(function(mfr, idx){
      var models = mfr.models || []; total += models.length;
      var open = idx === 0, bid = 'mmfit-b' + (++uid), hid = bid + '-h';
      var card = document.createElement('div');
      card.className = 'mmfit-brand' + (open ? ' open' : '');
      card.setAttribute('data-brand', mfr.manufacturer);
      var head = document.createElement('button');
      head.type = 'button'; head.className = 'mmfit-brand-head'; head.id = hid;
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      head.setAttribute('aria-controls', bid);
      head.innerHTML = '<span class="mmfit-brand-name">' + esc(tcase(mfr.manufacturer)) + '</span>'
                     + '<span class="mmfit-brand-count">' + models.length + ' model' + (models.length !== 1 ? 's' : '') + '</span>'
                     + '<svg class="mmfit-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';
      var body = document.createElement('div');
      body.className = 'mmfit-brand-body'; body.id = bid; body.setAttribute('role', 'region'); body.setAttribute('aria-labelledby', hid);
      var inner = document.createElement('div'), chips = document.createElement('div'); chips.className = 'mmfit-chips';
      models.forEach(function(m){
        var name = (m && m.name) || m, a = document.createElement('a');
        a.className = 'mmfit-chip'; a.setAttribute('data-model', name);
        // Fallback href (new-tab / no-JS): the Parts Finder pre-filtered to this machine.
        var pfFallback = '/pages/parts-finder?make=' + encodeURIComponent(mfr.manufacturer) + '&model=' + encodeURIComponent(name);
        a.href = pfFallback;
        a.textContent = name;
        // Plain left-click -> jump to this machine's make/model product page (resolved on click);
        // fall back to the Parts Finder if that machine has no dedicated page.
        a.addEventListener('click', function(e){
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
          e.preventDefault();
          if (a.__busy) return; a.__busy = true; a.style.opacity = '0.55';
          mmProductUrl(mfr.manufacturer, name).then(function(url){ window.location.href = url || pfFallback; });
        });
        chips.appendChild(a);
      });
      inner.appendChild(chips); body.appendChild(inner);
      head.addEventListener('click', function(){ var o = card.classList.toggle('open'); head.setAttribute('aria-expanded', o ? 'true' : 'false'); });
      card.appendChild(head); card.appendChild(body); c.appendChild(card);
    });
    return total;
  }

  function setAll(open){
    content().querySelectorAll('.mmfit-brand').forEach(function(card){
      card.classList.toggle('open', open);
      var h = card.querySelector('.mmfit-brand-head'); if(h) h.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function filter(q){
    q = (q || '').trim().toLowerCase();
    var cards = content().querySelectorAll('.mmfit-brand'), nr = $('mmfit-noresults');
    if(!q){
      var first = true;
      cards.forEach(function(card){
        card.hidden = false; card.classList.toggle('open', first);
        var h = card.querySelector('.mmfit-brand-head'); if(h) h.setAttribute('aria-expanded', first ? 'true' : 'false');
        card.querySelectorAll('.mmfit-chip').forEach(function(ch){ ch.classList.remove('mmfit-hit'); ch.textContent = ch.getAttribute('data-model'); });
        first = false;
      });
      if(nr) nr.hidden = true; return;
    }
    var anyVisible = false;
    cards.forEach(function(card){
      var brand = (card.getAttribute('data-brand') || '').toLowerCase(), brandHit = brand.indexOf(q) >= 0, modelHit = false;
      card.querySelectorAll('.mmfit-chip').forEach(function(ch){
        var m = ch.getAttribute('data-model') || '', ml = m.toLowerCase(), i = ml.indexOf(q);
        ch.classList.toggle('mmfit-hit', i >= 0 || brandHit);
        if(i >= 0){ modelHit = true; ch.innerHTML = esc(m.slice(0, i)) + '<mark>' + esc(m.slice(i, i + q.length)) + '</mark>' + esc(m.slice(i + q.length)); }
        else { ch.textContent = m; }
      });
      var show = brandHit || modelHit; card.hidden = !show;
      if(show){ anyVisible = true; card.classList.add('open'); var h = card.querySelector('.mmfit-brand-head'); if(h) h.setAttribute('aria-expanded', 'true'); }
    });
    if(nr) nr.hidden = anyVisible;
  }

  /* Arriving from a machine search (homepage make/model picker, or the collection-page
     filter) with ?fitment_make[&fitment_model]: show ONLY that brand rather than all ~15.
     The shopper already told us which machine they have. This reuses the tab's own search
     box — the make is placed in it visibly, so clearing the box restores every brand and
     doubles as the "show all" affordance. Falls through to the full list whenever the make
     is absent, unrecognised, or not one this track fits. (Task 6092 rev 4.) */
  function fitSlug(x){ return String(x == null ? '' : x).toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function prefillFitment(){
    var p; try { p = new URLSearchParams(window.location.search); } catch(e){ return; }
    var mk = (p.get('fitment_make') || '').trim();
    if (!mk) return;
    var c = content(); if (!c) return;
    var want = fitSlug(mk), brand = null;
    c.querySelectorAll('.mmfit-brand').forEach(function(card){
      var b = card.getAttribute('data-brand');
      if (!brand && fitSlug(b) === want) brand = b;
    });
    if (!brand) return;                       // not one of this track's brands — leave it alone
    var s = $('mmfit-search');
    if (s) s.value = brand;
    filter(brand);
    var md = (p.get('fitment_model') || '').trim();
    if (md){
      var want2 = fitSlug(md);
      c.querySelectorAll('.mmfit-chip').forEach(function(ch){
        if (fitSlug(ch.getAttribute('data-model')) === want2) ch.classList.add('mmfit-exact');
      });
    }
  }

  function apply(handle, data){
    var eq = (data && data.compatible_equipment) || [], total = render(eq);
    var btn = $('pp-mmfit-tab-btn'), b = $('pp-mmfit-tab-badge'), sub = $('pp-mmfit-hint'), s = $('mmfit-search'), nr = $('mmfit-noresults');
    if(s) s.value = ''; if(nr) nr.hidden = true;
    if(total > 0){
      if(btn) btn.style.display = ''; if(b){ b.textContent = total; b.style.display = ''; }
      if(sub) sub.textContent = 'Search or select your equipment brand below to confirm compatibility with this exact rubber track.';
    } else {
      if(btn) btn.style.display = ''; if(b) b.style.display = 'none';
      if(sub) sub.innerHTML = 'We don\'t have a full machine list for this exact track yet — call <a href="tel:8665168473">(866) 516-8473</a> and we\'ll confirm every machine it fits.';
    }
    prefillFitment();
  }

  var API = 'https://app.team1texas.com/apps/portal', API_TOKEN = 'sf_t1t_a8f3e2d1c4b5967081234abcdef56789';
  function load(handle){
    if(!handle) return;
    if(cache[handle]){ apply(handle, cache[handle]); return; }
    fetch(API + '/product-enhance/' + encodeURIComponent(handle), { headers: { 'Accept': 'application/json', 'X-Api-Token': API_TOKEN } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ var d = (j && j.data) || j || {}; cache[handle] = d; apply(handle, d); })
      .catch(function(){});
  }

  document.addEventListener('mmf:track-selected', function(e){ load(e.detail && e.detail.handle); });
  // Pick up a selection the picker resolved before this deferred script loaded (single-track pages).
  if(window.__mmfSelected && window.__mmfSelected.handle) load(window.__mmfSelected.handle);
  function wire(){
    var s = $('mmfit-search'); if(s && !s.__w){ s.__w = 1; s.addEventListener('input', function(){ filter(s.value); }); }
    var ex = $('mmfit-expand'); if(ex && !ex.__w){ ex.__w = 1; ex.addEventListener('click', function(){ setAll(true); }); }
    var co = $('mmfit-collapse'); if(co && !co.__w){ co.__w = 1; co.addEventListener('click', function(){ setAll(false); }); }
  }
  if(document.readyState !== 'loading') wire(); else document.addEventListener('DOMContentLoaded', wire);
})();
